/**
 * variant-popup.js
 * Fixed for Shopify Craft / Dawn themes (CartDrawer integration)
 * Configured: Out-of-stock options hidden, supports pre-selected card filters, price shows when full variant selected
 */

(function () {
  'use strict';

  /* ── Popup DOM refs ──────────────────────────────────────────────────── */
  var overlay        = document.getElementById('variant-popup-overlay');
  var closeBtn       = document.getElementById('vp-close');
  var loadingEl      = document.getElementById('vp-loading');
  var bodyEl         = document.getElementById('vp-body');
  var titleEl        = document.getElementById('vp-title');
  var priceRow       = document.querySelector('.vp-price-row');
  var comparePriceEl = document.getElementById('vp-compare-price');
  var currentPriceEl = document.getElementById('vp-current-price');
  var saveBadgeEl    = document.getElementById('vp-save-badge');
  var optionsEl      = document.getElementById('vp-options');
  var atcBtn         = document.getElementById('vp-atc-btn');
  var viewLink       = document.getElementById('vp-view-link');

  if (!overlay) return;

  var selectedOptions = {};
  var currentProduct  = null;

  /* ── Format money ──────────────────────────────────────────────────── */
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (_) {
      return '\u20B9' + Math.round(cents / 100).toLocaleString('en-IN');
    }
  }

  /* ── Modal open / close ─────────────────────────────────────────────── */
  function openModal() {
    overlay.removeAttribute('aria-hidden');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.style.overflow  = '';
    currentProduct  = null;
    selectedOptions = {};
    if (atcBtn) {
      atcBtn.textContent = 'Add to cart';
      atcBtn.classList.remove('is-added');
      delete atcBtn.dataset.variantId;
    }
    if (priceRow) priceRow.style.display = 'none';
    if (loadingEl) loadingEl.style.display = '';
    if (bodyEl) bodyEl.style.display       = 'none';
  }

  /* ── Fetch product JSON ─────────────────────────────────────────────── */
  function loadProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  /* ── Render variant option buttons (Only for Available Variants) ─────── */
  function renderOptions(product, preSelected) {
    optionsEl.innerHTML = '';

    var preSelectedLower = (preSelected || []).map(function (v) { 
      return String(v).toLowerCase(); 
    });

    product.options.forEach(function (option, idx) {
      var optionName = typeof option === 'string' ? option : option.name;
      var optionKey  = 'option' + (idx + 1);

      var values = [];
      product.variants.forEach(function (v) {
        if (!v.available) return;
        var val = v[optionKey];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      if (values.length === 0) return;

      var group = document.createElement('div');
      group.className = 'vp-option-group';

      var lbl = document.createElement('p');
      lbl.className   = 'vp-option-label';
      lbl.textContent = optionName;
      group.appendChild(lbl);

      var btnsWrap = document.createElement('div');
      btnsWrap.className = 'vp-option-btns';

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type        = 'button';
        btn.className   = 'vp-option-btn';
        btn.textContent = value;
        btn.dataset.optionName  = optionName;
        btn.dataset.optionValue = value;
        btn.setAttribute('aria-pressed', 'false');

        // Check if this option value was pre-selected (e.g. from a filter on product card)
        var valLower = value.toLowerCase();
        if (preSelectedLower.indexOf(valLower) !== -1 && selectedOptions[optionName] === undefined) {
          selectedOptions[optionName] = value;
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
        }

        btn.addEventListener('click', function () {
          group.classList.remove('is-missing');
          btnsWrap.querySelectorAll('.vp-option-btn').forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });

          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          selectedOptions[optionName] = value;
          onSelectionChange(product);
        });

        btnsWrap.appendChild(btn);
      });

      group.appendChild(btnsWrap);
      optionsEl.appendChild(group);
    });

    onSelectionChange(product);
  }

  /* ── Match selected options to variant ─────────────────────────────── */
  function matchVariant(product) {
    return product.variants.find(function (v) {
      return product.options.every(function (option, idx) {
        var optionName = typeof option === 'string' ? option : option.name;
        return v['option' + (idx + 1)] === selectedOptions[optionName];
      });
    });
  }

  /* ── Called on every option click or pre-selection ─────────────────── */
  function onSelectionChange(product) {
    var allChosen = product.options.every(function (option) {
      var optionName = typeof option === 'string' ? option : option.name;
      var optionKey  = 'option' + (product.options.indexOf(option) + 1);
      var hasAvailableValues = product.variants.some(function(v) { return v.available && v[optionKey]; });

      return !hasAvailableValues || selectedOptions[optionName] !== undefined;
    });

    if (!allChosen) {
      atcBtn.textContent = 'Add to cart';
      delete atcBtn.dataset.variantId;
      if (priceRow) priceRow.style.display = 'none';
      return;
    }

    var variant = matchVariant(product);
    if (!variant || !variant.available) {
      atcBtn.textContent = 'Unavailable';
      delete atcBtn.dataset.variantId;
      if (priceRow) priceRow.style.display = 'none';
      return;
    }

    atcBtn.textContent       = 'Add to cart';
    atcBtn.dataset.variantId = String(variant.id);
    currentPriceEl.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      comparePriceEl.textContent   = formatMoney(variant.compare_at_price);
      comparePriceEl.style.display = '';
      saveBadgeEl.textContent      = 'SAVE ' + pct + '%';
      saveBadgeEl.style.display    = '';
    } else {
      comparePriceEl.style.display = 'none';
      saveBadgeEl.style.display    = 'none';
    }

    if (priceRow) priceRow.style.display = '';
  }

  /* ── Open variant popup ─────────────────────────────────────────────── */
  function openVariantPopup(handle, productUrl, preSelected) {
    openModal();
    loadingEl.style.display = '';
    bodyEl.style.display    = 'none';
    selectedOptions         = {};
    if (priceRow) priceRow.style.display = 'none';

    loadProduct(handle)
      .then(function (product) {
        currentProduct = product;
        titleEl.textContent = product.title;
        viewLink.href = productUrl || ('/products/' + handle);

        renderOptions(product, preSelected || []);

        loadingEl.style.display = 'none';
        bodyEl.style.display    = 'flex';
      })
      .catch(function (err) {
        console.error('[VariantPopup]', err);
        closeModal();
      });
  }

  /* ── Trigger Theme Cart Drawer ──────────────────────────────────────── */
  function triggerCraftCart(response) {
    var cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      window.location.href = '/cart';
      return;
    }

    cartDrawer.classList.remove('is-empty');
    var innerDrawer = cartDrawer.querySelector('.drawer__inner');
    if (innerDrawer) {
      innerDrawer.classList.remove('is-empty');
    }

    if (typeof cartDrawer.renderContents === 'function' && response && response.sections) {
      cartDrawer.renderContents(response);
    }

    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'variant-popup', cart: response });
    }

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('animate', 'active');
    }
  }

  /* ── Get section objects from Dawn's CartDrawer ──────────────────────── */
  function getSectionsToRender() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender();
    }
    return [
      { id: 'cart-drawer', section: 'cart-drawer', selector: 'cart-drawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#cart-icon-bubble' }
    ];
  }

  /* ── AJAX add to cart ───────────────────────────────────────────────── */
  function addToCart(variantId, btn, onSuccess) {
    var originalHTML = btn.innerHTML;
    btn.disabled = true;

    var sectionObjects = getSectionsToRender();
    var sectionsToFetch = sectionObjects.map(function (s) {
      return s.section || s.id;
    });

    var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      })
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(d) {
          throw new Error(d.description || 'Error adding item');
        });
      }
      return r.json();
    })
    .then(function(response) {
      btn.classList.add('is-added');

      triggerCraftCart(response);

      if (typeof onSuccess === 'function') onSuccess();

      setTimeout(function() {
        btn.innerHTML = originalHTML;
        btn.disabled  = false;
        btn.classList.remove('is-added');
      }, 1500);
    })
    .catch(function(err) {
      console.error('[VariantPopup] ATC Error:', err);
      btn.innerHTML = originalHTML;
      btn.disabled  = false;
    });
  }

  /* ── Global click delegation ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('[data-action="open-variant-popup"]');
    if (chooseBtn) {
      e.preventDefault();
      var preSelected = [];
      try {
        preSelected = JSON.parse(chooseBtn.dataset.selectedOptions || '[]');
      } catch (err) { preSelected = []; }
      openVariantPopup(chooseBtn.dataset.productHandle, chooseBtn.dataset.productUrl, preSelected);
      return;
    }

    if (atcBtn && (e.target === atcBtn || atcBtn.contains(e.target))) {
      if (!currentProduct) return;

      var allSelected = currentProduct.options.every(function (option) {
        var optionName = typeof option === 'string' ? option : option.name;
        var optionKey  = 'option' + (currentProduct.options.indexOf(option) + 1);
        var hasAvailableValues = currentProduct.variants.some(function(v) { return v.available && v[optionKey]; });

        return !hasAvailableValues || selectedOptions[optionName] !== undefined;
      });

      if (!allSelected) {
        optionsEl.querySelectorAll('.vp-option-group').forEach(function (grp) {
          var label = grp.querySelector('.vp-option-label');
          var optName = label ? label.textContent : '';
          if (selectedOptions[optName] === undefined) {
            grp.classList.remove('is-missing');
            void grp.offsetWidth;
            grp.classList.add('is-missing');
          }
        });
        return;
      }

      if (atcBtn.dataset.variantId) {
        addToCart(atcBtn.dataset.variantId, atcBtn, function () {
          setTimeout(closeModal, 300);
        });
      }
      return;
    }

    if (e.target === overlay) { closeModal(); }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

})();